import { Table } from '@octano/global-ui';
import { useMemo } from 'react';

import { useTexts } from '../hooks/useTexts';
import { StudentStudyPlanRow } from '../types';

type Props = {
  studyPlans: StudentStudyPlanRow[];
};

// Marcador para las celdas sin dato (período o vía de admisión ausentes)
const EMPTY_VALUE = '-';

export function StudyPlansTable({ studyPlans }: Props) {
  const texts = useTexts();

  // El Table lee cada celda por columnName, así que aplanamos las filas a string
  const rows = useMemo(() => {
    return studyPlans.map((studyPlan) => {
      return {
        enrollmentId: studyPlan.enrollmentId,
        studyPlanName: studyPlan.studyPlanName || EMPTY_VALUE,
        periodEntryName: studyPlan.periodEntry?.name ?? EMPTY_VALUE,
        admissionViaName: studyPlan.admissionViaName ?? EMPTY_VALUE,
      };
    });
  }, [studyPlans]);

  return (
    <Table
      data={rows}
      noResultsText={texts.noResults}
      columns={[
        {
          headerText: texts.table.studyPlan,
          columnName: 'studyPlanName',
          width: '40%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.table.periodEntry,
          columnName: 'periodEntryName',
          width: '30%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
        {
          headerText: texts.table.admissionVia,
          columnName: 'admissionViaName',
          width: '30%',
          thClassName: 'text-center',
          tdClassName: 'text-center',
        },
      ]}
    />
  );
}
